import React, { HTMLAttributes } from "react";
import * as PropTypes from "prop-types";
import _ from "lodash";
import Cache from "core/cache/index";
import {
  //formatPN,
  formatDA,
  formatNumberPrecision,
  formatTM,
  formatDATM
} from "./common.format.js";
/// Message Modules
import pubsub from "core/global/global";
import CustomEvent from "core/customEvent/index";
import ShowDICOM from "core/DICOMtag";
import Helper from "core/helper/index";

import "./DCMTagOverlay.styl";

function is_collide(a: any, b: any) {
  if (!b) {
    let a = "sdadfadfad";
  }

  var aRect = a.getBoundingClientRect();
  var bRect = b.getBoundingClientRect();

  return !(
    aRect.top + aRect.height < bRect.top ||
    aRect.top > bRect.top + bRect.height ||
    aRect.left + aRect.width < bRect.left ||
    aRect.left > bRect.left + bRect.width
  );
}

/**
 * @description DCMTagOverlay UI Component Properties
 *
 * @interface IDCMTagOverlayProps
 * @extends {HTMLAttributes<HTMLDivElement>}
 */
interface IDCMTagOverlayProps extends HTMLAttributes<HTMLDivElement> {
  /**
   * @description DICOM stack 데이터
   */
  stack: any;
  /**
   * @description 현재 마우스 좌표
   */
  mousePos?: any;
  /**
   * @description DICOM Stack에서 현재 출력되는 DICOM 영상의 Index
   */
  imageIndex: number;
  /**
   * @description 뷰포트 설정 정보
   */
  viewport: any;
  /**
   * @description DICOM stack 에 포함된 영상 갯수
   */
  numImages: number;
  /**
   * @description 현재 DICOM Viewer 레이아웃 정보.
   * @deprecated
   */
  layoutString: string;
  value: string;
  levelPresetName: string;
  parentElement: any;
}

/**
 * @description DCMTagOverlay UI Class
 *
 * @class DCMTagOverlay
 * @extends {React.PureComponent<IDCMTagOverlayProps, any>}
 */
class DCMTagOverlay extends React.Component<IDCMTagOverlayProps, any> {
  static propTypes: PropTypes.InferProps<IDCMTagOverlayProps>;

  tokenToggleDicomTag = null;
  tokenNewMetadata = null;
  /**
   * Tag group div
   * @memberof DCMTagOverlay
   */
  topLeftTagDivGroup = null;
  topRightTagDivGroup = null;
  bottomLeftTagDivGroup = null;
  bottomRightTagDivGroup = null;
  /**
   * default property values
   *
   * @static
   * @memberof DCMTagOverlay
   */
  public static defaultProps = {
    stack: null,
    mousePos: null,
    value: "",
    levelPresetName: "",
    parentElement: null
  };

  constructor(props: any) {
    super(props);
    this.state = {
      numImages: props.numImages || 0
    };
  }

  componentDidMount() {
    this.tokenToggleDicomTag = (pubsub as any).subscribe(
      CustomEvent.Messages.TOGGLE_DICOM_TAG,
      this.handleToggleDicomTag.bind(this)
    );
    this.tokenNewMetadata = (pubsub as any).subscribe(
      CustomEvent.Messages.NEW_METADATA,
      this.handleNewMetadata.bind(this)
    );
  }

  componentWillUpdate(nextProps: any, nextState: any) {
    (this.state.numImages as any) = nextProps.numImages;
  }

  componentWillUnmount() {
    (pubsub as any).unsubscribe(this.tokenToggleDicomTag);
    (pubsub as any).unsubscribe(this.tokenNewMetadata);
  }

  handleToggleDicomTag() {
    this.forceUpdate();
  }

  handleNewMetadata() {
    let metadataCache = new Cache.Metadata();
    const numOfFrame = metadataCache.getNumOfFrame(this.props.stack);
    this.setState({
      numImages: numOfFrame
    });
  }

  /**
   * @method isControlVisible
   * @description DCM 데이터가 한장이라도 있다면, DCMTagOverlay 를 출력
   * @memberof DCMTagOverlay
   */
  isControlVisible = () => {
    // let isVisible = true;
    // if (this.detectTagGroupOverlapped()) {
    //   isVisible = false;
    // }
    //let controlVisible = isVisible ? "visible" : "invisible";
    let controlVisible = this.getNumImages() >= 1 ? "controlsVisible" : "";
    return "imageViewerViewportOverlay noselect nodrag " + controlVisible;
    //return "";
  };

  /**
   * @method getFrameIndex
   * @description DICOM Stack에서 현재 출력중인 DICOM 영상의 인덱스 반환
   * @return DICOM Stack에서 현재 출력중인 DICOM 영상의 인덱스
   * @memberof DCMTagOverlay
   */
  getFrameIndex = () => {
    let frameIndex = 0;

    if (this.props.imageIndex !== undefined) {
      frameIndex = this.props.imageIndex;
    }

    return frameIndex;
  };

  /**
   * @method getWindowWidth
   * @description DICOM Stack의 windowWidth 반환
   * @return DICOM Stack의 windowWidth 반환
   * @todo DICOM Stack에서 현재 출력중인 DICOM 영상의 windowWidth 반환하도록 수정
   * @memberof DCMTagOverlay
   */
  getWindowWidth() {
    let data = this.props.stack;
    if (!data) {
      return "";
    }

    let metadataCache = new Cache.Metadata();
    const windowWidth = metadataCache.getWindowWidth(this.props.stack);

    if (typeof windowWidth === undefined) {
      return "";
    }

    if (windowWidth === undefined || windowWidth === null) {
      return "";
    }

    return windowWidth;
  }

  /**
   * @method getWindowCenter
   * @description DICOM Stack의 WindowCenter 반환
   * @return DICOM Stack의 WindowCenter 반환
   * @todo DICOM Stack에서 현재 출력중인 DICOM 영상의 WindowCenter 반환하도록 수정
   * @memberof DCMTagOverlay
   */
  getWindowCenter() {
    let data = this.props.stack;
    if (!data) {
      return "";
    }

    let metadataCache = new Cache.Metadata();
    const windowCenter = metadataCache.getWindowCenter(this.props.stack);

    if (typeof windowCenter === undefined) {
      return "";
    }

    if (windowCenter === undefined || windowCenter === null) {
      return "";
    }

    return windowCenter;
  }

  /**
   * @method getWWWC
   * @description DICOM Stack의 WW/WC 반환
   * @return DICOM Stack의 WW/WC 반환
   * @todo DICOM Stack에서 현재 출력중인 DICOM 영상의 WW/WC 반환하도록 수정
   * @memberof DCMTagOverlay
   */
  getWWWC() {
    //let viewport = this.props.viewport.viewport;
    let viewport = this.props.viewport;

    if (!viewport) {
      return "";
    }
    if (viewport.voi === null || viewport.voi === undefined) {
      return "";
    }

    let windowWidth: any = 0.0;
    let windowCenter: any = 0.0;

    if (
      viewport.voi.windowWidth === null ||
      viewport.voi.windowWidth === undefined
    ) {
      windowWidth = this.getWindowWidth();
    } else {
      windowWidth = viewport.voi.windowWidth;
    }
    if (
      viewport.voi.windowCenter === null ||
      viewport.voi.windowCenter === undefined
    ) {
      windowCenter = this.getWindowCenter();
    } else {
      windowCenter = viewport.voi.windowCenter;
    }

    if (
      !windowWidth ||
      !windowCenter ||
      windowWidth === "" ||
      windowCenter === ""
    ) {
      return "";
    }
    return (
      //"WL : " + windowCenter.toFixed(0) + " WW : " + windowWidth.toFixed(0)
      "WL : " + windowCenter.toFixed(0) + " WW : " + windowWidth.toFixed(0)
    );
  }

  /**
   * @method getZoom
   * @description 현재 뷰포트의 확대 비율 반환
   * @return 현재 뷰포트의 확대 비율
   * @memberof DCMTagOverlay
   */

  getZoom() {
    let viewport = this.props.viewport;
    if (!viewport) {
      return "";
    }

    return viewport.scale * 100.0;
  }

  /**
   * @method getImageDimensions
   * @description 현재 출력중인 영상의 크기 반환
   * @return 현재 출력중인 영상의 크기
   * @memberof DCMTagOverlay
   */
  getImageDimensions() {
    let frameIndex = this.props.imageIndex;
    let data = this.props.stack;

    if (!data) {
      return "";
    }
    if (frameIndex === undefined || frameIndex === null) {
      return "";
    }

    if (frameIndex === -1) {
      return "";
    }

    let metadataCache = new Cache.Metadata();
    const image = metadataCache.getFrame(this.props.stack, frameIndex);

    let textDims = "";
    if (!image) {
      return "";
    }

    const numCols = data.getRows(this.props.stack);
    const numRows = data.getColmns(this.props.stack);

    if (
      numCols === null ||
      numRows === undefined ||
      (numRows === null || numRows === undefined)
    ) {
      textDims = "";
    } else {
      textDims = numCols + " x " + numRows;
    }

    return textDims;
  }

  /**
   * @method getPatientName
   * @description 현재 출력중인 DICOM Stack의 환자 이름 반환
   * @return 현재 출력중인 DICOM Stack의 환자 이름
   * @memberof DCMTagOverlay
   */
  getPatientName() {
    let data = this.props.stack;
    if (!data) {
      return "";
    }

    let metadataCache = new Cache.Metadata();
    const patientName = metadataCache.getPatientName(this.props.stack);

    if (typeof patientName === undefined) {
      return "";
    }

    if (patientName === undefined || patientName === null) {
      return "";
    }

    return patientName;
  }

  /**
   * @method getPatientId
   * @description 현재 출력중인 DICOM Stack의 환자 ID 반환
   * @return 현재 출력중인 DICOM Stack의 환자 ID
   * @memberof DCMTagOverlay
   */
  getPatientId() {
    let data = this.props.stack;

    if (!data) {
      return "";
    }

    let metadataCache = new Cache.Metadata();
    const patientID = metadataCache.getPatientId(this.props.stack);

    if (typeof patientID === undefined) {
      return "";
    }

    if (patientID === undefined || patientID === null) {
      return "";
    }

    return patientID;
  }

  /**
   * @method getPatientBirthDate
   * @description 현재 출력중인 DICOM Stack의 환자 생일 반환
   * @return 현재 출력중인 DICOM Stack의 환자 생일
   * @memberof DCMTagOverlay
   */
  getPatientBirthDate() {
    let data = this.props.stack;

    if (!data) {
      return "";
    }
    let metadataCache = new Cache.Metadata();
    const patientBirthdate = metadataCache.getPatientBirthDate(
      this.props.stack
    );

    if (typeof patientBirthdate === undefined) {
      return "";
    }

    if (patientBirthdate === undefined || patientBirthdate === null) {
      return "";
    }

    return patientBirthdate;
  }

  /**
   * @method getPatientSex
   * @description 현재 출력중인 DICOM Stack의 환자 성별 반환
   * @return 현재 출력중인 DICOM Stack의 환자 성별
   * @memberof DCMTagOverlay
   */
  getPatientSex() {
    let data = this.props.stack;
    if (!data) {
      return "";
    }

    let metadataCache = new Cache.Metadata();
    const patientSex = metadataCache.getPatientSex(this.props.stack);

    if (typeof patientSex === undefined) {
      return "";
    }

    if (patientSex === undefined || patientSex === null) {
      return "";
    }

    return patientSex;
  }

  /**
   * @method getStudyDate
   * @description 현재 출력중인 DICOM Stack의 스터디 날짜 반환
   * @return 현재 출력중인 DICOM Stack의 스터디 날짜
   * @memberof DCMTagOverlay
   */
  getStudyDate() {
    let data = this.props.stack;
    if (!data) {
      return "";
    }
    let metadataCache = new Cache.Metadata();
    const studyDate = metadataCache.getStudyDate(this.props.stack);
    if (typeof studyDate === undefined) {
      return "";
    }

    if (studyDate === undefined || studyDate === null) {
      return "";
    }

    return studyDate;
  }

  /**
   * @method getStudyTime
   * @description 현재 출력중인 DICOM Stack의 스터디 시간 반환
   * @return 현재 출력중인 DICOM Stack의 스터디 시간
   * @memberof DCMTagOverlay
   */
  getStudyTime() {
    let data = this.props.stack;
    if (!data) {
      return "";
    }
    let metadataCache = new Cache.Metadata();
    const studyTime = metadataCache.getStudyTime(this.props.stack);
    if (typeof studyTime === undefined) {
      return "";
    }

    if (studyTime === undefined || studyTime === null) {
      return "";
    }

    return studyTime;
  }

  /**
   * @method getStudyDescription
   * @description 현재 출력중인 DICOM Stack의 StudyDescription 반환
   * @return 현재 출력중인 DICOM Stack의 StudyDescription
   * @memberof DCMTagOverlay
   */
  getStudyDescription() {
    let data = this.props.stack;
    if (!data) {
      return "";
    }
    let metadataCache = new Cache.Metadata();
    const studyDescription = metadataCache.getStudyDescription(
      this.props.stack
    );
    if (typeof studyDescription === undefined) {
      return "";
    }

    if (studyDescription === undefined || studyDescription === null) {
      return "";
    }

    return studyDescription;
  }

  /**
   * @method getSeriesDescription
   * @description 현재 출력중인 DICOM Stack의 SeriesDescription 반환
   * @return 현재 출력중인 DICOM Stack의 SeriesDescription
   * @memberof DCMTagOverlay
   */
  getSeriesDescription() {
    let data = this.props.stack;
    if (!data) {
      return "";
    }
    let metadataCache = new Cache.Metadata();
    const seriesDescription = metadataCache.getSeriesDescription(
      this.props.stack
    );
    if (typeof seriesDescription === undefined) {
      return "";
    }

    if (seriesDescription === undefined || seriesDescription === null) {
      return "";
    }

    return seriesDescription;
  }

  /**
   * @method getSeriesNumber
   * @description 현재 출력중인 DICOM Stack의 시리즈 번호 반환
   * @return 현재 출력중인 DICOM Stack의 시리즈 번호
   * @memberof DCMTagOverlay
   */
  getSeriesNumber() {
    let data = this.props.stack;
    if (!data) {
      return "";
    }
    let metadataCache = new Cache.Metadata();
    const seriesNumber = metadataCache.getSeriesNumber(this.props.stack);
    if (typeof seriesNumber === undefined) {
      return "";
    }

    if (seriesNumber === undefined || seriesNumber === null) {
      return "";
    }

    return seriesNumber;
  }

    /**
   * @method getInstanceNumber
   * @description 현재 출력중인 DICOM Stack의 시리즈 번호 반환
   * @return 현재 출력중인 DICOM Stack의 시리즈 번호
   * @memberof DCMTagOverlay
   */
  getInstanceNumber() {
    let data = this.props.stack;
    if (!data) {
      return "";
    }
    let metadataCache = new Cache.Metadata();
    const instanceNumber = metadataCache.getInstanceNumber(this.props.stack);
    if (typeof instanceNumber === undefined) {
      return "";
    }

    if (instanceNumber === undefined || instanceNumber === null) {
      return "";
    }

    return instanceNumber;
  }

  /**
   * @method getThickness
   * @description 현재 출력중인 DICOM Stack의 sliceThickness 반환
   * @return 현재 출력중인 DICOM Stack의 sliceThickness
   * @memberof DCMTagOverlay
   */
  getThickness() {
    let data = this.props.stack;
    if (!data) {
      return "";
    }
    let metadataCache = new Cache.Metadata();
    const sliceThickness = metadataCache.getThickness(this.props.stack);
    if (typeof sliceThickness === undefined) {
      return "";
    }

    if (sliceThickness === undefined || sliceThickness === null) {
      return "";
    }

    return sliceThickness;
  }

  /**
   * @method getLocation
   * @description 현재 출력중인 DICOM Stack의 sliceLocation 반환
   * @return 현재 출력중인 DICOM Stack의 sliceLocation
   * @memberof DCMTagOverlay
   */

  getLocation() {
    // Displays Slice Location (0020,1041), if present.
    // - Otherwise, displays Table Position (0018,9327)
    // - TODO: Otherwise, displays a value derived from Image Position (Patient) (0020,0032)

    let data = this.props.stack;
    if (!data) {
      return "";
    }

    let metadataCache = new Cache.Metadata();
    const sliceLocation = metadataCache.getSliceLocation(this.props.stack);
    const tablePosition = metadataCache.getTablePosition(this.props.stack);
    const imagePositionPatient = metadataCache.getImagePositionPatient(
      this.props.stack
    );

    if (typeof sliceLocation === undefined) {
      return "";
    }

    if (sliceLocation === undefined || sliceLocation === null) {
      return "";
    }

    if (sliceLocation !== "") {
      return sliceLocation;
    }

    if (typeof tablePosition === undefined) {
      return "";
    }

    if (tablePosition === undefined || tablePosition === null) {
      return "";
    }

    if (tablePosition !== "") {
      return tablePosition;
    }

    if (typeof imagePositionPatient === undefined) {
      return "";
    }

    if (imagePositionPatient === undefined || imagePositionPatient === null) {
      return "";
    }

    return imagePositionPatient;
  }

  /**
   * @method getInstitutionName
   * @description 현재 출력중인 DICOM Stack의 InstitutionName 반환
   * @return 현재 출력중인 DICOM Stack의 InstitutionName
   * @memberof DCMTagOverlay
   */
  getInstitutionName() {
    let data = this.props.stack;
    if (!data) {
      return "";
    }
    let metadataCache = new Cache.Metadata();
    const institutionName = metadataCache.getInstitutionName(this.props.stack);
    if (typeof institutionName === undefined) {
      return "";
    }

    if (institutionName === undefined || institutionName === null) {
      return "";
    }

    return institutionName;
  }

  /**
   * @method getInstitutionAddress
   * @description 현재 출력중인 DICOM Stack의 InstitutionAddress 반환
   * @return 현재 출력중인 DICOM Stack의 InstitutionAddress
   * @memberof DCMTagOverlay
   */
  getInstitutionAddress() {
    let data = this.props.stack;
    if (!data) {
      return "";
    }
    let metadataCache = new Cache.Metadata();
    const institutionAddress = metadataCache.getInstitutionAddress(
      this.props.stack
    );
    if (typeof institutionAddress === undefined) {
      return "";
    }

    if (institutionAddress === undefined || institutionAddress === null) {
      return "";
    }

    return institutionAddress;
  }

  /**
   * @method getXRayTubeCurrent
   * @description 현재 출력중인 DICOM Stack의 XRayTube 반환
   * @return 현재 출력중인 DICOM Stack의 XRayTube
   * @memberof DCMTagOverlay
   */
  getXRayTubeCurrent() {
    let data = this.props.stack;
    if (!data) {
      return "";
    }

    if (typeof data.XRayTubeCurrent === undefined) {
      return "";
    }

    if (data.XrayTubeCurrent === undefined || data.XrayTubeCurrent === null) {
      return "";
    }

    return data.XRayTubeCurrent + "mA";
  }

  /**
   * @method getKVP
   * @description 현재 출력중인 DICOM Stack의 KVP 반환
   * @return 현재 출력중인 DICOM Stack의 KVP
   * @memberof DCMTagOverlay
   */
  getKVP() {
    let data = this.props.stack;
    if (!data) {
      return "";
    }
    let metadataCache = new Cache.Metadata();
    const KVP = metadataCache.getKVP(this.props.stack);
    if (typeof KVP === undefined) {
      return "";
    }

    if (KVP === undefined || KVP === null) {
      return "";
    }

    return KVP + "kV";
  }
  getAcquisitionTag() {
    const acquisitionDate = formatDA(this.getAcquisitionDate(), "YYYY-MM-DD");
    const acquisitionTime = formatTM(this.getAcquisitionTime(), "a hh:mm:ss");

    if (
      acquisitionDate !== "" &&
      acquisitionDate !== undefined &&
      acquisitionDate !== null
    ) {
      return acquisitionDate + " " + acquisitionTime;
    }

    const performedProcedureStepID = this.getPerformedProcedureStepID();
    if (
      performedProcedureStepID !== "" &&
      performedProcedureStepID !== undefined &&
      performedProcedureStepID !== null
    ) {
      return performedProcedureStepID;
    }

    const studyDate = this.getStudyDate();
    const studyTime = this.getStudyTime();
    if (
      (studyTime !== "" && studyTime !== undefined && studyTime !== null) ||
      (studyDate !== "" && studyDate !== undefined && studyDate !== null)
    ) {
      let formatStudyTime: any = "";
      if (studyTime.includes(".")) {
        formatStudyTime = formatTM(studyTime, "a hh:mm:ss");
      } else {
        formatStudyTime = formatTM(studyTime, "a hh:mm:ss", "hh:mm:ss.SSS");
      }

      return formatDA(studyDate, "YYYY-MM-DD") + " " + formatStudyTime;
    }

    return "";
  }
  getPerformedProcedureStepID() {
    let data = this.props.stack;
    if (!data) {
      return "";
    }
    let frameIndex = 0;
    if (this.props.imageIndex !== undefined) {
      frameIndex = this.props.imageIndex;
    } else {
      return "";
    }

    let metadataCache = new Cache.Metadata();
    const performedProcedureStepID = metadataCache.getPerformedProcedureStepID(
      this.props.stack,
      frameIndex
    );

    if (typeof performedProcedureStepID === undefined) {
      return "";
    }

    if (
      performedProcedureStepID === undefined ||
      performedProcedureStepID === null
    ) {
      return "";
    }

    return formatDATM(performedProcedureStepID, "YYYY-MM-DD HH:MM:SS");
  }
  /**
   * @method getAcquisitionDate
   * @description 현재 출력중인 DICOM Stack의 AcquisitionDate 반환
   * @return 현재 출력중인 DICOM Stack의 AcquisitionDate
   * @memberof DCMTagOverlay
   */
  getAcquisitionDate() {
    let data = this.props.stack;
    if (!data) {
      return "";
    }
    let metadataCache = new Cache.Metadata();
    const frameIndex = this.getFrameIndex();
    //const acquisitionDate = metadataCache.getAcquisitionDate(this.props.stack);
    const acquisitionDate = metadataCache.getAcquisitionDateFromFrame(
      this.props.stack,
      frameIndex
    );

    if (typeof acquisitionDate === undefined) {
      return "";
    }

    if (acquisitionDate === undefined || acquisitionDate === null) {
      return "";
    }

    return acquisitionDate;
  }

  /**
   * @method getAcquisitionTime
   * @description 현재 출력중인 DICOM Stack의 AcquisitionTime 반환
   * @return 현재 출력중인 DICOM Stack의 AcquisitionTime
   * @memberof DCMTagOverlay
   */
  getAcquisitionTime() {
    let data = this.props.stack;
    if (!data) {
      return "";
    }
    let metadataCache = new Cache.Metadata();
    const frameIndex = this.getFrameIndex();
    //const acquisitionTime = metadataCache.getAcquisitionTime(this.props.stack);
    const acquisitionTime = metadataCache.getAcquisitionTimeFromFrame(
      this.props.stack,
      frameIndex
    );
    if (typeof acquisitionTime === undefined) {
      return "";
    }

    if (acquisitionTime === undefined || acquisitionTime === null) {
      return "";
    }

    return acquisitionTime;
  }

  /**
   * @method getSpacingBetweenSlices
   * @description 현재 출력중인 DICOM Stack의 SpacingBetweenSlices 반환
   * @return 현재 출력중인 DICOM Stack의 SpacingBetweenSlices
   * @memberof DCMTagOverlay
   */
  getSpacingBetweenSlices() {
    // Displays Spacing Between Slices (0018,0088), if present.

    // TODO: Otherwise, displays a value derived from successive values
    // of Image Position (Patient) (0020,0032) perpendicular to
    // the Image Orientation (Patient) (0020,0037)
    let data = this.props.stack;
    if (!data) {
      return "";
    }
    let metadataCache = new Cache.Metadata();
    const spacingBetweenSlices = metadataCache.getSpacingBetweenSlices(
      this.props.stack
    );
    if (typeof spacingBetweenSlices === undefined) {
      return "";
    }

    if (spacingBetweenSlices === undefined || spacingBetweenSlices === null) {
      return "";
    }

    return spacingBetweenSlices;
  }

  /**
   * @method getCompression
   * @description 현재 출력중인 DICOM Stack의 Compression 반환
   * @return 현재 출력중인 DICOM Stack의 Compression
   * @memberof DCMTagOverlay
   */
  getCompression() {
    // Displays whether or not lossy compression has been applied:
    //
    // - Checks Lossy Image Compression (0028,2110)
    // - If so, displays the value of Lossy Image Compression Ratio (0028,2112)
    //          and Lossy Image Compression Method (0028,2114)
    let data = this.props.stack;
    if (!data) {
      return "";
    }

    let metadataCache = new Cache.Metadata();
    const lossyImageCompressionMethod = metadataCache.getLossyImageCompressionMethod(
      this.props.stack
    );
    const lossyImageCompression = metadataCache.getLossyImageCompression(
      this.props.stack
    );
    const lossyImageCompressionRatio = metadataCache.getLossyImageCompressionRatio(
      this.props.stack
    );

    if (lossyImageCompression === "01" && lossyImageCompressionRatio !== "") {
      const compressionMethod = lossyImageCompressionMethod || "Lossy: ";
      const compressionRatio = parseFloat(lossyImageCompressionRatio).toFixed(
        2
      );
      return compressionMethod + compressionRatio + " : 1";
    }
    return "";
    //return 'Lossless / Uncompressed';
  }

  /**
   * @method getNumImages
   * @description 현재 출력중인 DICOM Stack의 이미지 갯수 반환
   * @return 현재 출력중인 DICOM Stack의 이미지 갯수
   * @memberof DCMTagOverlay
   */
  getNumImages() {
    let numImages = 0;

    // if (this.props.numImages !== undefined && this.props.numImages !== null) {
    //   numImages = this.props.numImages;
    // }

    if (this.state.numImages !== undefined && this.state.numImages !== null) {
      numImages = this.state.numImages;
    }

    return numImages;
  }

  /**
   * @method getLayoutString
   * @description 현재 DICOM Viewer의 레이아웃 설정 사항을 리턴
   * @return 현재 DICOM Viewer의 레이아웃 설정 사항
   * @memberof DCMTagOverlay
   */
  getLayoutString() {
    let layoutString = "1x1";

    if (this.props.layoutString !== undefined) {
      layoutString = this.props.layoutString;
    }
    return layoutString;
  }

  /**
   * @method getStudyID
   * @description 현재 출력중인 DICOM Stack의 StudyID 반환
   * @return 현재 출력중인 DICOM Stack의 StudyID
   * @memberof DCMTagOverlay
   */
  getStudyID() {
    let data = this.props.stack;
    if (!data) {
      return "";
    }
    let metadataCache = new Cache.Metadata();
    const studyID = metadataCache.getStudyID(this.props.stack);
    if (typeof studyID === undefined) {
      return "";
    }

    if (studyID === undefined || studyID === null) {
      return "";
    }

    return studyID;
  }

  /**
   * @method getImageComment
   * @description 현재 출력중인 DICOM Stack의 ImageComment 반환
   * @return 현재 출력중인 DICOM Stack의 ImageComment
   * @memberof DCMTagOverlay
   */
  getImageComment() {
    let data = this.props.stack;
    if (!data) {
      return "";
    }
    let metadataCache = new Cache.Metadata();
    const imageComment = metadataCache.getImageComment(this.props.stack);
    if (typeof imageComment === undefined) {
      return "";
    }

    if (imageComment === undefined || imageComment === null) {
      return "";
    }

    return imageComment;
  }

  /**
   * @method getStudyComment
   * @description 현재 출력중인 DICOM Stack의 StudyComment 반환
   * @return 현재 출력중인 DICOM Stack의 StudyComment
   * @memberof DCMTagOverlay
   */
  getStudyComment() {
    let data = this.props.stack;
    if (!data) {
      return "";
    }
    let metadataCache = new Cache.Metadata();
    const studyComment = metadataCache.getStudyComment(this.props.stack);
    if (typeof studyComment === undefined) {
      return "";
    }

    if (studyComment === undefined || studyComment === null) {
      return "";
    }

    return studyComment;
  }

  /**
   * @method getFieldStrenth
   * @description 현재 출력중인 DICOM Stack의 FieldStrenth 반환
   * @return 현재 출력중인 DICOM Stack의 FieldStrenth
   * @memberof DCMTagOverlay
   */
  getFieldStrenth() {
    let data = this.props.stack;
    if (!data) {
      return "";
    }
    let metadataCache = new Cache.Metadata();
    const fieldStrenth = metadataCache.getFieldStrenth(this.props.stack);
    if (typeof fieldStrenth === undefined) {
      return "";
    }

    if (fieldStrenth === undefined || fieldStrenth === null) {
      return "";
    }

    //return "FS: " + parseInt(data.fieldStrenth).toFixed(1);
    return "FS: " + parseInt(fieldStrenth);
  }

  /**
   * @method getRepetitionTime
   * @description 현재 출력중인 DICOM Stack의 RepetitionTime 반환
   * @return 현재 출력중인 DICOM Stack의 RepetitionTime
   * @memberof DCMTagOverlay
   */
  getRepetitionTime() {
    let data = this.props.stack;
    if (!data) {
      return "";
    }

    let metadataCache = new Cache.Metadata();
    const repetitionTime = metadataCache.getRepetitionTime(this.props.stack);

    if (typeof repetitionTime === undefined) {
      return "";
    }

    if (repetitionTime === undefined || repetitionTime === null) {
      return "";
    }

    return "TR: " + parseFloat(repetitionTime).toFixed(1);
  }

  /**
   * @method getEchoTime
   * @description 현재 출력중인 DICOM Stack의 EchoTime 반환
   * @return 현재 출력중인 DICOM Stack의 EchoTime
   * @memberof DCMTagOverlay
   */
  getEchoTime() {
    let data = this.props.stack;
    if (!data) {
      return "";
    }
    let metadataCache = new Cache.Metadata();
    const echoTime = metadataCache.getEchoTime(this.props.stack);
    if (typeof echoTime === undefined) {
      return "";
    }

    if (echoTime === undefined || echoTime === null) {
      return "";
    }

    return "TE: " + parseFloat(echoTime).toFixed(1);
  }

  getIsNagative() {
    const { viewport } = this.props;
    if (viewport.invert) {
      return "[N]";
    }
    return "";
  }
  getMousePosition() {
    const { mousePos } = this.props;

    if (
      mousePos === null ||
      typeof mousePos === undefined ||
      mousePos === undefined
    ) {
      return "";
    }

    if (mousePos.x === -1 || mousePos.y === -1) {
      return "";
    }

    if (!_.get(mousePos, "x") || !_.get(mousePos, "y")) {
      return "";
    }

    const positionText =
      "X : " + parseInt(mousePos.x) + " Y : " + parseInt(mousePos.y);
    return positionText;
  }

  getValue() {
    const { value } = this.props;

    return value;
  }

  getLevelPresetName() {
    const { levelPresetName } = this.props;
    return levelPresetName;
  }

  detectDivRunOutFromParent(element: any) {
    const { parentElement } = this.props;
    if (!parentElement) {
      return false;
    }

    const parentRect = parentElement.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();

    /// check top/left
    if (
      elementRect.top < parentRect.top ||
      elementRect.left < parentRect.left
    ) {
      return true;
    }

    // /// check right
    // if (elementRect.right > parentRect.right) {
    //   return true;
    // }

    // /// check bottom
    // if (elementRect.bottom > parentRect.bottom) {
    //   return true;
    // }

    return false;
  }

  detectTagGroupOverlapped() {
    var topLeftItems = Array.prototype.slice.call(
      document.getElementsByClassName("top-left-item"),
      0
    );
    var topRightItems = Array.prototype.slice.call(
      document.getElementsByClassName("top-right-item"),
      0
    );
    var bottomRightItems = Array.prototype.slice.call(
      document.getElementsByClassName("bottom-right-item"),
      0
    );
    var bottomLeftItems = Array.prototype.slice.call(
      document.getElementsByClassName("bottom-left-item"),
      0
    );

    if (
      !topLeftItems.length ||
      !topRightItems.length ||
      !bottomRightItems.length ||
      !bottomLeftItems.length
    ) {
      return false;
    }

    let tagGroup = [];
    tagGroup.push(
      topLeftItems,
      topRightItems,
      bottomRightItems,
      bottomLeftItems
    );
    const numOfGroups: number = tagGroup.length;
    const groupLength: number = tagGroup.length;

    for (let i = 0; i < numOfGroups; i++) {
      for (let j = i + 1; j < numOfGroups; j++) {
        const targetGroup1 = tagGroup[i];
        const targetGroup2 = tagGroup[j];

        const numOfGroup1 = targetGroup1.length;
        const numOfGroup2 = targetGroup2.length;

        for (let k = 0; k < numOfGroup1; k++) {
          const targetDiv1 = targetGroup1[k];
          for (let l = 0; l < numOfGroup2; l++) {
            const targetDiv2 = targetGroup2[l];

            /// 부모 Element 밖으로 나가진 않았는지 확인
            if (this.detectDivRunOutFromParent(targetDiv1)) {
              return true;
            }
            if (this.detectDivRunOutFromParent(targetDiv2)) {
              return true;
            }

            const isColliding = is_collide(targetDiv1, targetDiv2);
            if (isColliding) {
              return true;
            }
          }
        }
      }
    }

    return false;
  }

  // detectTagGroupOverlapped() {
  //   var topLeftItems = Array.prototype.slice.call(
  //     document.getElementsByClassName("top-left-item"),
  //     0
  //   );
  //   var topRightItems = Array.prototype.slice.call(
  //     document.getElementsByClassName("top-right-item"),
  //     0
  //   );
  //   var bottomRightItems = Array.prototype.slice.call(
  //     document.getElementsByClassName("bottom-right-item"),
  //     0
  //   );
  //   var bottomLeftItems = Array.prototype.slice.call(
  //     document.getElementsByClassName("bottom-left-item"),
  //     0
  //   );

  //   if (
  //     !topLeftItems.length ||
  //     !topRightItems.length ||
  //     !bottomRightItems.length ||
  //     !bottomLeftItems.length
  //   ) {
  //     return false;
  //   }

  //   let tagGroup = Array.prototype.concat.call(
  //     topLeftItems,
  //     topRightItems,
  //     bottomRightItems,
  //     bottomLeftItems
  //   );

  //   const groupLength: number = tagGroup.length;
  //   for (let i = 0; i < groupLength; i++) {
  //     const targetDiv1 = tagGroup[i];
  //     for (let j = i + 1; j < groupLength; j++) {
  //       const targetDiv2 = tagGroup[j];
  //       const isColliding = is_collide(tagGroup[18], tagGroup[15]);
  //       if (isColliding) {
  //         return true;
  //       }
  //     }
  //   }

  //   return false;
  // }

  // detectTagGroupOverlapped() {
  //   if (
  //     !this.topLeftTagDivGroup ||
  //     !this.topRightTagDivGroup ||
  //     !this.bottomLeftTagDivGroup ||
  //     !this.bottomRightTagDivGroup
  //   ) {
  //     return false;
  //   }
  //   let tagGroup = [];
  //   tagGroup.push(this.topLeftTagDivGroup);
  //   tagGroup.push(this.topRightTagDivGroup);
  //   tagGroup.push(this.bottomLeftTagDivGroup);
  //   tagGroup.push(this.bottomRightTagDivGroup);

  //   const groupLength: number = tagGroup.length;
  //   for (let i = 0; i < groupLength; i++) {
  //     const targetDiv1 = tagGroup[i];
  //     for (let j = i + 1; j < groupLength; j++) {
  //       const targetDiv2 = tagGroup[j];
  //       const isColliding = is_collision(targetDiv1, targetDiv2);
  //       if (isColliding) {
  //         return true;
  //       }
  //     }
  //   }

  //   return false;
  // }

  /**
   * @method shouldComponentUpdate
   * @description 렌더링 조건 정의
   * @return true - 렌더링 수행, false - 렌더링 하지 않음
   * @memberof DCMTagOverlay
   */
  shouldComponentUpdate(nextProps: any, nextState: any) {
    const viewportChanged = _.isEqual(this.props.viewport, nextProps.viewport);

    return viewportChanged;
  }

  renderDicomTags() {
    if (!ShowDICOM.getIsShowDICOMTag()) {
      return;
    }

    // if (this.detectTagGroupOverlapped()) {
    //   return;
    // }
    return (
      <React.Fragment>
        <div className={this.isControlVisible()}>
          <div
            className="top-left dicomTag"
            ref={(ref: any) => (this.topLeftTagDivGroup = ref)}
          >
            <span className="top-left-item" style={this.props.style}>
              {this.getSeriesNumber() >= 0
                ? `Se: ${this.getSeriesNumber()}`
                : ""}
            </span>
            <span className="top-left-item" style={this.props.style}>
              {this.getInstanceNumber() >= 0
                ? //? `Im : ${this.getFrameIndex() }/${this.getNumImages() - 1}`
                  `Instance : ${this.getInstanceNumber()}`
                : ""}
            </span>
            
            <span className="top-left-item" style={this.props.style}>
              {this.getNumImages() > 1
                ? //? `Im : ${this.getFrameIndex() }/${this.getNumImages() - 1}`
                  `Im : ${this.getFrameIndex() + 1}/${this.getNumImages()}`
                : ""}
            </span>
            <span className="compressionIndicator top-left-item">
              {this.getCompression()}
            </span>
            {/* <div className="priorIndicator">{'not supported'}</div> */}
          </div>
          <div
            className="top-right dicomTag"
            ref={(ref: any) => (this.topRightTagDivGroup = ref)}
          >
            <span className="top-right-item" style={this.props.style}>
              {this.getPatientName()}
            </span>
            <span className="top-right-item" style={this.props.style}>
              {this.getPatientId()}
            </span>
            <span className="top-right-item" style={this.props.style}>
              {formatDA(this.getPatientBirthDate(), "YYYY-MM-DD")}{" "}
              {this.getPatientSex()}
            </span>
            <span className="top-right-item" style={this.props.style}>
              {this.getInstitutionName()}
            </span>
            <span className="top-right-item" style={this.props.style}>
              {this.getStudyID()}
            </span>
            <span className="top-right-item" style={this.props.style}>
              {this.getStudyDescription()}
            </span>
            <span className="top-right-item" style={this.props.style}>
              {this.getSeriesDescription()}
            </span>
            <span className="top-right-item" style={this.props.style}>
              {this.getImageComment()}
            </span>
            <span className="top-right-item" style={this.props.style}>
              {this.getStudyComment()}
            </span>
          </div>
          <div
            className="bottom-right dicomTag"
            ref={(ref: any) => (this.bottomRightTagDivGroup = ref)}
          >
            <span className="bottom-right-item" style={this.props.style}>
              {this.getXRayTubeCurrent()} {this.getKVP()}
            </span>
            <span className="bottom-right-item" style={this.props.style}>
              {this.getFieldStrenth()}
            </span>
            <span className="bottom-right-item" style={this.props.style}>
              {this.getRepetitionTime()} {this.getEchoTime()}
            </span>
            <span className="bottom-right-item" style={this.props.style}>
              {this.getAcquisitionTag()}
              {/* {formatDA(this.getAcquisitionDate(), "YYYY-MM-DD")}{" "}
              {formatTM(this.getAcquisitionTime(), "HH:MM:SS")} */}
            </span>
          </div>
          <div
            className="bottom-left dicomTag"
            ref={(ref: any) => (this.bottomLeftTagDivGroup = ref)}
          >
            <span className="bottom-left-item" style={this.props.style}>
              {this.getMousePosition()} {this.getValue()}
            </span>
            <span className="bottom-left-item" style={this.props.style}>
              {" "}
              {this.getWWWC()} {this.getIsNagative()}{" "}
              {this.getLevelPresetName()}
            </span>

            <span className="bottom-left-item" style={this.props.style}>
              {this.getThickness()
                ? `T: ${formatNumberPrecision(this.getThickness(), "2")} mm`
                : ""}
              {Helper.Validator.isNumber(this.getLocation())
                ? ` L: ${formatNumberPrecision(this.getLocation(), "2")} mm`
                : ""}
            </span>
          </div>
        </div>
      </React.Fragment>
    );
  }

  /**
   * @method render
   * @description DCMTagOverlay UI 컴포넌트 렌더링
   * @return 렌더링된 DCMTagOverlay React Element
   * @memberof DCMTagOverlay
   */
  render() {
    const { style } = this.props;
    if (!style || !style.fontSize) {
      return;
    }

    return <React.Fragment>{this.renderDicomTags()}</React.Fragment>;
  }
}

export default DCMTagOverlay;
